<template>
  <div style="position: relative">
    <div class="d-flex justify-center">
      <div class="border mr-3" :style="{ border: `1px solid ${color}` }"></div>
      <div>
        <div class="d-flex align-end mb-2" style="width: 360px; margin: auto">
          <div style="width: 200px">
            <InstructionSelector
              :value="oneKeywordRule.instructionId"
              @change="onChangeInstruction"
              dense
              dark
              hide-details
            ></InstructionSelector>
          </div>
          <div class="mx-4"></div>
          <div style="width: 140px">
            <v-text-field v-model="inputWord" label="키워드입력" dark hide-details>
              <template v-slot:append-outer>
                <v-btn @click="onAddWord(inputWord)" icon outlined x-small>
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </div>
        </div>
        <div style="width: 360px; margin: auto; min-height: 24.77px">
          <v-chip
            v-for="word in oneKeywordRule.keywords"
            :key="word"
            close
            @click:close="onRemoveWord(word)"
            :color="color"
            text-color="black"
            small
          >
            {{ word }}
          </v-chip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: Number,
    seedOneKeywordRule: {
      type: Object,
      default: () => ({ _id: null, label: null, animationId: null, keywords: [] }),
    },
  },
  mounted() {
    this.oneKeywordRule = JSON.parse(JSON.stringify(this.seedOneKeywordRule));

    // actionId 기준 or animationId 기준
    this.oneKeywordRule.animationId = this.oneKeywordRule.actionId || this.oneKeywordRule.animationId;
    this.selectedActionId = this.oneKeywordRule.animationId; // 근데 실제 들어있는 값은 지금 actionId임
  },
  data() {
    return {
      inputWord: null,
      //
      oneKeywordRule: {
        _id: null,
        label: null,
        animationId: null,
        keywords: [],
      },
    };
  },
  methods: {
    _emitOnChange() {
      this.$emit("change", this.oneKeywordRule);
    },

    onClickDelete() {
      this.$emit("delete", this.oneKeywordRule._id);
    },
    // 다 emit 해야 하는 것들
    onAddWord(word) {
      if (!word) return;
      this.oneKeywordRule.keywords.push(word);
      this.inputWord = null;
      this._emitOnChange();
    },
    onRemoveWord(word) {
      this.oneKeywordRule.keywords = this.oneKeywordRule.keywords.filter((w) => w !== word);
      this._emitOnChange();
    },
    onChangeInstruction(instructionId) {
      this.oneKeywordRule.instructionId = instructionId;
      this._emitOnChange();
    },
  },
  computed: {
    color() {
      return this.index % 2 === 0 ? "red" : "#6F9ECD";
    },
  },
};
</script>

<style scoped>
.border {
  border: 1px solid #9155fd;
  border-radius: 2px;
}
</style>
